import { render } from "./TagManagementView.vue?vue&type=template&id=1cf28b92&scoped=true&ts=true"
import script from "./TagManagementView.vue?vue&type=script&lang=ts"
export * from "./TagManagementView.vue?vue&type=script&lang=ts"

import "./TagManagementView.vue?vue&type=style&index=0&id=1cf28b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf28b92"]])

export default __exports__